import shell from './shell';
import common from './common';
import reviews from './reviews';
import settings from './settings';
import settingsTwo from './settingsTwo';
import workspace from './workspace';
import reputation from './reputation';
import listings from './listings';


// Fixture registry for role preview mode: endpoint path → () => response body.
// One file per module; later files win if two define the same endpoint.
const FIXTURES = {
	...shell,
	...common,
	...reviews,
	...settings,
	...settingsTwo,
	...workspace,
	...reputation,
	...listings
}; // Empty success that survives the common ways callers read a response:
// as an array (.map/.length), or as { hits, total, docs, options, data, ... }.

const emptyResult = () => Object.assign([], {
	status: 200,
	hits: [],
	total: 0,
	docs: [],
	options: [],
	data: [],
	reviewTags: [],
	content: []
}); // Pages write into the responses they get (e.g. response.status = 200), so every call gets its own copy.
// Lists keep their extra properties (some fixtures are lists that also carry hits/total/options).


const copy = v => {
	if (Array.isArray(v)) {
		const out = v.map(copy);
		Object.keys(v).forEach(k => {
			if (!/^d+$/.test(k)) out[k] = copy(v[k]);
		});
		return out;
	}

	if (v && typeof v === 'object') {
		const out = {};
		Object.keys(v).forEach(k => {
			out[k] = copy(v[k]);
		});
		return out;
	}

	return v;
};

export const fixtureFor = (path, config) => {
	const key = Object.keys(FIXTURES).find(k => path === k || path.endsWith(k));
	return key ? copy(FIXTURES[key](config)) : emptyResult();
};
